import React from "react"

const IconContacts = ({className}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path className={className}
        d="M21.75,18.75H11.25l-6,4.5v-4.5h-3a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5v15A1.5,1.5,0,0,1,21.75,18.75Z"/>
</svg>

export default IconContacts